import {
  UIRouter,
  Transition,
  HookResult,
  TransitionService
} from '@uirouter/angular';

import { RouterBaseService, MenuService,  ConsumerType, CONSUMER_TYPE, CONSUMERS } from '@tdwb/core';

export class NewUserRouterConfigService {
  static routerConfig(uiRouter: UIRouter): void {
    NewUserRouterConfigService.initHooks(uiRouter.transitionService);
  }

  static initHooks(transitionService: TransitionService): void {
    transitionService.onSuccess({ to: 'page.**' }, (transition: Transition): HookResult => {
      const menuService: MenuService = transition.injector().get(MenuService);
      const routerService: RouterBaseService = transition.injector().get(RouterBaseService);
      const consumerType: ConsumerType = transition.injector().get(CONSUMER_TYPE);
      const state = routerService.getCurrentStateName();
      if(consumerType.consumerId === CONSUMERS.CONSUMER_ID_EASY_TRADE &&
        NewUserRouterConfigService.hideFooterStateForLiteNewUser(state)) {
        menuService.hideFooter();
      } else {
        menuService.showFooter();
      }
    });
  }

  private static hideFooterStateForLiteNewUser(state: string): boolean {
    const listOfStates = [
      'page.new-user.getting-started',
      'page.new-user.terms-and-conditions-lite',
      'page.new-user.sign-exchange-agreements',
      'page.new-user.eservices-signup'
    ];
    return listOfStates.includes(state);
  }
}
